import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthorForm } from "./contexts/AuthorFormContext";

export default function AuthorFormPage() {
  const [searchParams] = useSearchParams();
  const updateAuthorId = searchParams.get("id");

  const { data, isLoading, error, isDone, handleData, handleCreate, handleUpdate, handleDelete, image, setImage, fetchData } = useAuthorForm();

  useEffect(() => {
    if (updateAuthorId) {
       fetchData(updateAuthorId);
    }
  }, [updateAuthorId]);
  

  return (
    <main className="container mt-3">
      <div className="d-flex align-items-center justify-content-center gap-3">
        {updateAuthorId ? (
          <h3 className="text-white bg-warning px-3 py-2 rounded-pill text-uppercase fw-bold small">
            Update
          </h3>
        ) : (
          <h3 className="text-white bg-success px-3 py-2 rounded-pill text-uppercase fw-bold small">
            Create
          </h3>
        )}
        <h1 className="fw-bold h4">Author | Form</h1>
      </div>

      <section className="row justify-content-center">
        <div className="w-75">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (updateAuthorId) {
                handleUpdate(updateAuthorId);
              } else {
                handleCreate();
              }
            }}
            className="p-4 bg-light rounded shadow-sm"
          >
            {/* Author Name */}
            <div className="mb-3">
              <label className="form-label">
                Author Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Author Name"
                type="text"
                onChange={(e) => handleData("name", e.target.value)}
                value={data?.name}
                required
              />
            </div>

            {/* Author Email */}
            <div className="mb-3">
              <label className="form-label">
                Author Email <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Author Email"
                type="email"
                onChange={(e) => handleData("email", e.target.value)}
                value={data?.email}
                required
              />
            </div>

            {/* Image Preview */}
            {data?.photoURL && (
              <div className="mb-3 text-center">
                <img
                  className="img-thumbnail"
                  src={data?.photoURL}
                  alt="Author Photo"
                  width="150"
                />
              </div>
            )}
            {image && (
              <div className="mb-3 text-center">
                <img
                  className="img-thumbnail"
                  src={URL.createObjectURL(image)}
                  alt="Preview"
                  width="150"
                />
              </div>
            )}

            {/* Image Upload */}
            <div className="mb-3">
              <label className="form-label">Image</label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>

            {/* Error Message */}
            {error && <p className="text-danger">{error}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary w-100"
            >
              {isLoading ? "Loading..." : updateAuthorId ? "Update" : "Create"}
            </button>

            {/* Delete Button */}
            {updateAuthorId && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleDelete(updateAuthorId);
                }}
                disabled={isLoading}
                className="btn btn-danger w-100 mt-2"
              >
                Delete
              </button>
            )}

            {/* Success Message */}
            {isDone && (
              <h3 className="text-success text-center mt-3 fw-bold">
                Successfully {updateAuthorId ? "Updated" : "Created"}!
              </h3>
            )}
          </form>
        </div>
      </section>
    </main>
  );
}
